"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenOnThemeChanged = void 0;
const tslib_1 = require("tslib");
/** Start listening on theme changed */
function listenOnThemeChanged(client, options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (options && options.customTheme)
            return;
        const cssLink = document.createElement('link');
        cssLink.setAttribute('rel', 'stylesheet');
        document.head.prepend(cssLink);
        client.onload(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            client.on('theme', 'themeChanged', (_theme) => setTheme(cssLink, _theme));
            const theme = yield client.call('theme', 'currentTheme');
            setTheme(cssLink, theme);
        }));
        return cssLink;
    });
}
exports.listenOnThemeChanged = listenOnThemeChanged;
function setTheme(cssLink, theme) {
    cssLink.setAttribute('href', theme.url);
    document.documentElement.style.setProperty('--theme', theme.quality);
}
//# sourceMappingURL=theme.js.map